import { NavLink, Outlet } from "react-router-dom"
import Header from "../../components/Header"
// 
const NavigationItem: React.FC<{ to?: string, title: string }> = ({ to = "/", title }) => {
    return <NavLink end className={({ isActive }) => `rounded-t-lg ${isActive ? "text-zinc-700 bg-white" : "bg-transparent text-white"} px-5 py-2`} to={to}>{title}</NavLink>
}

const RankingNavigation = () => {
    return (
        <div className="px-5 md:px-32 flex items-center gap-5 bg-[#faa700] overflow-x-auto">
            <NavigationItem to={`/ranking/season`} title="Temporada" />
            <NavigationItem to={`/ranking/historical`} title="Histórico" />
        </div>
    )
}

const RankingPage = () => {
    return (
        <div className="flex flex-col">
            <Header className="flex flex-col gap-5 bg-[#faa700]">
                <p className="text-white font-extrabold uppercase text-4xl">Ranking</p>
                <p className="text-white">En estas tablas solo aparecerán los 10 mejores jugadores historicos o de temporada.</p>
            </Header>
            <RankingNavigation />

            <Outlet />
        </div>
    )
}

export default RankingPage